export default {
  stats: {
    orders: 'Bestellingen',
    sales: 'Omzet',
  },
};
